(function () {
	'use strict';

	/**
	 * @ngdoc type
	 * @name mx.shell.WizardRoadmap
	 * @module mx.shell
	 *
	 * @description
	 * Type that contains information about wizard steps, areas and all additional info needed to support user following wizard steps.
	 * A constructor accepts `options` parameter that may contain fields to extend corresponding properties.
	 *
	 * ```javascript
	 var roadmap = new WizardRoadmap({
		title: 'Sample Wizard! ',
		description: 'Some general info about wizard',
		steps: [
			new WizardRoadmapStep({
				title: 'Step 1',
				description: 'On this step we perform actions related to step 1.',
				orderNum: 1
			}),
			new WizardRoadmapStep({
				title: 'Step 2',
				description: 'On this step we perform actions related to step 2.',
				orderNum: 2
			})
		]
	 });
	 * ```
	 * @property {string} title - Gets or sets a title to be shown on roadmap's top
	 * @property {string} description - Gets or sets detailed information about wizard this roadmap is related to
	 * @property {mx.shell.WizardRoadmapStep[]} steps - Gets or sets an array of {@ref mx.shell.WizardRoadmapStep wizard steps}.<br>Default is `[]`
	 */
	angular.module('mx.shell').factory('mx.shell.WizardRoadmap', [
		function wizardRoadmapFactory() {
			return WizardRoadmap;
		},
	]);

	function WizardRoadmap(options) {
		let that = this;

		Object.defineProperty(that, 'title', { writable: true });
		Object.defineProperty(that, 'key', {
			writable: true,
			value: 'Undefined',
		});
		Object.defineProperty(that, 'description', { writable: true });
		Object.defineProperty(that, 'steps', {
			writable: true,
			value: [],
		});

		that = angular.extend(that, options);

		// Sorting steps by orderNum
		if (Array.isArray(that.steps)) {
			that.steps.sort(function (step1, step2) {
				return step1.orderNum - step2.orderNum;
			});
		}
	}
})();
